import { mapState, mapGetters, mapActions } from 'vuex';

// @ is an alias to /src
import Footer from '@/components/Footer.vue';
//import Aside from '@/components/Aside.vue';
//import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import TrainingCampItem from '@/views/TrainingCamp/TrainingCamps/components/TrainingCampItem.vue';

import { LOADING_MESSAGE } from './TrainingCamps.constants';

const GetCourseMultiTaskStatusMixin = {
  name: 'GetCourseMultiTaskStatusMixin',

  methods: {
    ...mapActions('TrainingCamp/TrainingCamps', {
      ma_getCourseMultiTaskStatus: 'getCourseMultiTaskStatus',
    }),

    getCourseMultiTaskStatus() {
      this.ma_getCourseMultiTaskStatus({
        courseId: this.$route.params.courseId,
      });
    },
  },

  created() {
    this.getCourseMultiTaskStatus();
  },
}

export default {
  name: 'TrainingCamps',

  mixins: [GetCourseMultiTaskStatusMixin],

  components: {
    Footer,
    //Aside,
    //WayFindBar,
    ToolBar,
    //TabBar,
    Spinner,
    TrainingCampItem,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('TrainingCamp/TrainingCamps', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('TrainingCamp/TrainingCamps', {
      mg_xlyList: 'xlyList',
    }),
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
